import { v4 } from 'uuid';
import { IFeeData, ISettlementItemData } from './ISectionData';

export interface ISettlementItemForm
  extends Omit<
    ISettlementItemData,
    'statementSettlementAndFeeCategoryDefinitionId' | 'settlementStatementItemId' | 'statementFees'
  > {
  isNew?: boolean;
  settlementStatementItemId?: string;
  statementSettlementAndFeeCategoryDefinitionId?: string;
  statementFees: ICreateSettlementFeeForm[];
}

export const createDefaultSettlementItemForm = (
  settlementSectionId?: string,
  currentSettlementItem?: Partial<ISettlementItemData>
): ISettlementItemForm => {
  if (currentSettlementItem) {
    const { statementFees, ...rest } = currentSettlementItem;
    return {
      settlementSectionId,
      createdAt: '',
      numericSettlementStatementPropertyValues: {} as { [key: string]: number },
      stringSettlementStatementPropertyValues: {} as { [key: string]: string },
      ...rest,
      statementFees: statementFees?.map((fee) => ({ ...fee, key: fee.statementFeeId })) ?? [
        createDefaultSettlementFeeForm({}),
      ],
    };
  } else {
    return {
      isNew: true,
      settlementSectionId,
      createdAt: '',
      numericSettlementStatementPropertyValues: {} as { [key: string]: number },
      stringSettlementStatementPropertyValues: {} as { [key: string]: string },
      statementFees: [createDefaultSettlementFeeForm({})],
    };
  }
};

export interface ICreateSettlementFeeForm
  extends Omit<
    IFeeData,
    'statementSettlementAndFeeCategoryDefinitionId' | 'statementFeeId' | 'statementSettlementItemId' | 'createdAt'
  > {
  key: string;
  statementFeeId?: string;
  statementSettlementItemId?: string;
  statementSettlementAndFeeCategoryDefinitionId?: string;
}

type ICreationFields = Partial<ICreateSettlementFeeForm>;

export const createDefaultSettlementFeeForm = ({
  statementSettlementAndFeeCategoryDefinitionId,
  numericFeePropertyValues = {},
  stringFeePropertyValues = {},
  linkedDocumentIds = [],
  disbursementIds = [],
  key = v4(),
}: ICreationFields): ICreateSettlementFeeForm => ({
  key,
  statementSettlementAndFeeCategoryDefinitionId,
  stringFeePropertyValues,
  numericFeePropertyValues,
  linkedDocumentIds,
  disbursementIds,
});
